import { useState } from "react";
import { removeFromSet, toggleSetItem } from "~/helpers/set";

export const useBulkSelection = <TId>(eligibleIds: TId[]) => {
  const [selectedIds, setSelectedIds] = useState<Set<TId>>(() => new Set());

  const allSelected =
    eligibleIds.length > 0 && selectedIds.size === eligibleIds.length;

  const toggleRow = (id: TId) =>
    setSelectedIds((prev) => toggleSetItem(prev, id));

  const toggleAll = () => {
    setSelectedIds((prev) => {
      if (prev.size === eligibleIds.length && eligibleIds.length > 0) {
        return new Set();
      }
      return new Set(eligibleIds);
    });
  };

  const deselect = (ids: TId[]) =>
    setSelectedIds((prev) => {
      let next = prev;
      for (const id of ids) next = removeFromSet(next, id);
      return next;
    });

  const clearSelection = () => setSelectedIds(() => new Set());

  // All selected when id is in selection, else just id
  const bulkTargets = (id: TId): Set<TId> =>
    selectedIds.has(id) ? selectedIds : new Set([id]);

  return {
    selectedIds,
    allSelected,
    toggleRow,
    toggleAll,
    deselect,
    clearSelection,
    bulkTargets,
  };
};
